module.exports = __webpack_public_path__ + "static/logo_m-fbed56b3a8e8d9520ebe60048f516668.svg";